import React, { useLayoutEffect, useState } from "react";
import styled from "styled-components";
import Header from "./Header";
import Sidebar from "./Sidebar";
import useWindowSize from "../util/hooks/useWindowSize";
import { useRBAC } from "../context/rbac/RBACContext";
import { DashboardModules } from "../config/app.config";
import { BREAKPOINTS } from "../config/breakpoints";

const Layout = styled.div`
	height: 100%;
	width: 100%;
	font-family: "Roboto", sans-serif;
	display: flex;
	flex-direction: column;
`;

const Content = styled.div`
	position: relative;
	width: 100%;
	flex: 1;
	min-width: 0;
	overflow-y: auto;
	overflow-x: hidden;
	height: 100%;
`;

const Div = styled.div`
	position: relative;
	display: flex;
	height: 100%;
	width: 100%;
	overflow-x: hidden;
`;

const MachineLayout = (props) => {
	const [width] = useWindowSize();
	const isMobile = width < BREAKPOINTS.tablet;
	const [showSidebar, toggle] = useState(false);
	useLayoutEffect(() => {
		toggle(!isMobile);
	}, [isMobile]);
	const { allowedSidebarLinksPerModule } = useRBAC();
	const allowedSidebarLinks = allowedSidebarLinksPerModule[DashboardModules.KIOSK];

	return (
		<Layout>
			<Header machinePage showSidebar={showSidebar} toggle={toggle} />
			<Div>
				<Sidebar config={allowedSidebarLinks} showSidebar={showSidebar} toggle={toggle} />
				<Content>{props.children}</Content>
			</Div>
		</Layout>
	);
};

export default MachineLayout;
